import axios from './api';


export default {
  signUp(user) {
    return axios.post('/api/auth/sign-up', user).then(res => res.data);
  },
  signIn(credentials) {
    return axios.post('/api/auth/sign-in', credentials).then(res => res.data);
  },
  signInAs(userId){
    return axios.post('api/auth/sign-in-as', userId).then(res => res.data)
  }
}